import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'es';

  const toggle = () => {
    i18n.changeLanguage(currentLang === 'es' ? 'en' : 'es');
  };

  return (
    <button
      onClick={toggle}
      title={currentLang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
      className="flex items-center gap-1 px-2 py-1 rounded border border-slate-500 text-slate-200 text-xs font-bold tracking-widest hover:border-slate-300 hover:text-white transition-colors duration-150 select-none"
    >
      <span className={currentLang === 'es' ? 'opacity-100' : 'opacity-40'}>ES</span>
      <span className="text-slate-500">|</span>
      <span className={currentLang === 'en' ? 'opacity-100' : 'opacity-40'}>EN</span>
    </button>
  );
};

export default LanguageSwitcher;
